import axios from "axios";
import {BASE_PATH} from "../services/api";

export const getLogs = async () => {
    return axios.get(BASE_PATH + "/admin/get-logs", {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
};
